<template>
  <div class="card card-info" v-else>
    <div class="card-header">
      <h3 class="card-title" style="width: 100%">
        <button v-on:click="AddNew()" type="button" class=" float-left btn btn-sm btn-outline-secondary btn-default"> <i class="fa fa-plus"> Add New</i></button>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-sm text-sm" width="100%">
              <thead class="bg-info">
                <tr>
                  <td align="center">Session</td>
                  <td align="center">Program</td>
                  <td align="center">Date</td>
                  <td align="center">Test Name</td>
                  <td align="center">Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in allInterviewRecord">
                  <td align="center">{{item.Session}}</td>
                  <td align="center">{{item.program[0]}}</td>
                  <td align="right">{{item.Date}}</td>
                  <td align="center">{{item.TestName}}</td>
                  <td align="center"> <i class="fa fa-2x fa-edit" v-on:click="edit(item.InterviewID, item.TotalMarks)"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({

    data() {
      return {
        allInterviewRecord: [],
      }
    },

    created: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        startReq();
        axios.get("/api/AdmissionApi/pageLoadAllInterview")
          .then(function (res) {
            endReq();
            if (res.data.status) {
              vm.allInterviewRecord = res.data.record;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },

      AddNew() {
        window.location.href = "../Admission/NewInterviewForm";
      },
      edit(interID, totalMarks) {
        var vm = this;

        axios.post("/api/AdmissionApi/checkinterviewupdate?id=" + interID + '&totalmarks=' + totalMarks)
          .then(function (res) {
            if (res.data.status) {
              window.location.href = "../Admission/NewInterviewForm?id=" + interID + '&totalmarks=' + totalMarks;
            }
            else {
              toastr.error(res.data.msg);
            }
          })
          .catch(function (error) {

          });
      },
    },
  });


</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/allInterviewForm.vue